import "./Inspections.module.css";
import Header from "@/reusable_sections/Header";
import Warranty from "./sections/Warranty";
import Problemstatement from "./sections/Problemstatement";
import Specifications from "./sections/Specifications";
import Assessments from "./sections/Assessments";
import GetYourQuoteCTA from "./sections/GetYourQuoteCTA";
import Process from "./sections/Process";
import Inspection from "./sections/Inspection";
import Footer from "@/reusable_sections/Footer";
export default function InspectionsPage() {
  return <div>
      <Header />
      <Warranty />
      <Problemstatement />
      <Specifications />
      <Assessments />
      <GetYourQuoteCTA />
      <Process />
      <Inspection />
      <Footer />
    </div>;
}